<template>
  <div id="Kft">
    <SovecoNavBar />
    <div class="tabs is-boxed is-marginless">
      <ul class="vehicles_top_tabs">
        <li :class="isTabActive(2)" @click="clickTab(2)">
          <a>Grafici Storici Autisti</a>
        </li>
        <li :class="isTabActive(3)" @click="clickTab(3)">
          <a>Situazione scarico DDD</a>
        </li>
        <li :class="isTabActive(4)" @click="clickTab(4)">
          <a>Archivio DDD</a>
        </li>
        <li :class="isTabActive(5)" @click="clickTab(5)">
          <a>Esportazione Lista Conducenti</a>
        </li>
      </ul>
    </div>
    <template v-if="tabNo === 2">
      <div class="columns">
        <div class="column is-narrow">
          <WeekChooser />
          <div ref="icardList" class="parent">
            <ul>
              <li
                v-for="item in icards_found"
                :key="item.icard"
                @click="doGraph(item)"
                @mouseover="isHovering = item"
                :class="[
                  isHovering === item
                    ? 'is-item-selected'
                    : 'is-item-not-selected',
                  'pl-1 pt-1 pb-1 pointer',
                ]"
              >
                <div class="columns px-3">
                  <div class="column">{{ item.icard }}</div>
                  <div class="column">{{ item.autista }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="column">
          <div v-if="selectedDriver" class="title_drivername">
            {{ selectedDriver.autista }}&nbsp;:&nbsp;{{ selectedDriver.icard }}
            <div v-for="item in reports" :key="item.key" class="graphRow">
              <div v-if="checkFuture(item)">
                <div class="rowDate">
                  <h3>{{ item.date | datesolo }}</h3>
                </div>
                <div class="border">
                  <TimetableCardWeek :report="item.report" />
                  <TimeLine :options="optGraph" :data="item.timeline" />
                </div>
              </div>
            </div>
            <div class="graphRow">
              <div class="rowDate">
                <h3>TOTALI</h3>
              </div>
              <div class="border" v-if="total">
                <TimetableCardTotal :total="total" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabNo === 3">
      <div class="generic_top_box">
        Situazione scarico DDD Veicoli e Conducenti
      </div>
      <div v-if="isLoading" class="spinner">
        <VueElementLoading :active="isLoading" spinner="ring" color="#0000FF" />
      </div>
      <div v-else>
        <VueScrollTable
          ref="kft3"
          :options="optionsDDD"
          :columns="columnsDDD"
          :rows="rowsDDD"
        />
      </div>
    </template>
    <template v-if="tabNo === 4">
      <div class="columns">
        <div class="column is-narrow">
          <table class="sr_history_table">
            <tr>
              <td>
                <div class="sr_history_table_label">Dal</div>
              </td>
              <TD>&nbsp;</TD>
              <td>
                <date-picker
                  v-model="startData"
                  type="datetime"
                  value-type="YYYY-MM-DD HH:mm"
                  format="DD-MM-YYYY HH:mm"
                  confirm
                ></date-picker>
              </td>
            </tr>
            <tr>
              <td>
                <div class="sr_history_table_label">Al</div>
              </td>
              <TD>&nbsp;</TD>
              <td>
                <date-picker
                  v-model="endData"
                  type="datetime"
                  value-type="YYYY-MM-DD HH:mm"
                  format="DD-MM-YYYY HH:mm"
                  confirm
                ></date-picker>
              </td>
            </tr>
          </table>

          <section>
            <div class="pad_bottom has-text-centered">
              <BUTTON
                class="button is-success buttonsize is-small"
                @click="doSearchDDD()"
                >CERCA</BUTTON
              >
            </div>
          </section>
        </div>
      </div>
      <div v-if="isLoading" class="spinner">
        <VueElementLoading :active="isLoading" spinner="ring" color="#0000FF" />
      </div>
      <div v-else>
        <VueScrollTable
          ref="kft4"
          :options="optionsADDD"
          :columns="columnsADDD"
          :rows="rowsADDD"
          :recalc="recalcFlag"
          v-on:recalc="recalcFlag = false"
        />
      </div>
    </template>
    <template v-if="tabNo === 5">
      <div class="generic_top_box">Esportazione Lista Conducenti</div>
      <div v-if="isLoading" class="spinner">
        <VueElementLoading :active="isLoading" spinner="ring" color="#0000FF" />
      </div>
      <div v-else class="columns">
        <div class="column">
          <VueScrollTable
            ref="kft5"
            :options="optionsExpoDrivers"
            :columns="columnsExpoDrivers"
            :rows="rowsExpoDrivers"
          />
        </div>
        <div class="column modal_style">
          <div class="box drivers_scheda_top_box">
            <p>
              Esportazione Conducenti
              <br />
              <br />Tramite questa funzione è possibile esportare i conducenti
              presenti nel sistema <br />cronotachigrafo nel sistema Sovecotech.
              <br />
              <br />Non verranno esportati i conducenti già presenti nel sistema
              Sovecotech evidenziati <br />nella lista con la lettera X
              <br />
              <br />Selezionare la check-box dei conducenti che si vogliono
              esportare.
              <br />
            </p>
          </div>
          <div class="pt-6">
            <button class="button" @click="doCheckBox()">
              Seleziona/Deseleziona tutti</button
            >&nbsp;
            <button class="button is-success buttonsize" @click="doExport()">
              Esporta
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
import VueElementLoading from 'vue-element-loading'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
import WeekChooser from './reusable/WeekChooser.vue'
import TimeLine from './reusable/TimeLine.vue'
import TimetableCardWeek from './reusable/TimetableCardWeek.vue'
import TimetableCardTotal from './reusable/TimetableCardTotal.vue'

export default {
  name: 'Kft',
  components: {
    VueScrollTable,
    VueElementLoading,
    DatePicker,
    WeekChooser,
    TimeLine,
    TimetableCardWeek,
    TimetableCardTotal,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      total: null,
      selectedDriver: null,
      optGraph: { height: 15, width: 900 },
      reports: [],
      totals: {},
      icards_found: [],
      myChart: null,
      vehicleSel: ({}.PerifId = -1),
      recalcFlag: false,
      grapBoxWidth: 1000,
      cardIdSelected: '',
      isLoading: false,
      isLoadingCarb: false,
      tabNo: 2,
      apiServer: '',
      startData: '',
      endData: '',
      rowsReport: [],
      rowsCardId: [],
      rowsGraph: [],
      driversRows: [],
      chartDataCollection: [],
      auth: null,
      prefs: null,
      theWeek: null,
      optionsDDD: {
        id: 'KFT003',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_small_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'LastInfoDate',
      },
      columnsDDD: [],
      rowsDDD: [],

      optionsADDD: {
        id: 'KFT004',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_small_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'LastInfoDate',
      },
      columnsADDD: [],
      rowsADDD: [],
      optionsExpoDrivers: {
        id: 'KFT005',
        isResizeable: true,
        isSelectable: true,
        cssContainer: '',
        cssHeader: 'table_list_small_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'nomelista',
      },
      columnsExpoDrivers: [],
      rowsExpoDrivers: [],
      drivers: [],
      trucks: [],
      windowHeight: 0,
      chartData: [],
      chartOptions: {
        chart: {
          title: 'Autista',
          subtitle: '12-10-2019',
        },
        hAxis: {
          format: 'HH:mm',
        },
      },

      chartOpt1: {
        scales: {
          yAxes: [
            {
              ticks: { beginAtZero: true },
              gridLines: { display: true },
              position: 'left',
              display: true,
              type: 'linear',
              id: 'A',
            },
            {
              ticks: { beginAtZero: true },
              gridLines: { display: true },
              position: 'right',
              display: true,
              type: 'linear',
              id: 'B',
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour',
                unitStepSize: 1,
                displayFormats: { hour: 'HH:mm' },
              },
              xAxisID: 'C',
            },
          ],
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      chartOpt2: {
        scales: {
          yAxes: [
            {
              ticks: { beginAtZero: true },
              gridLines: { display: true },
              position: 'left',
              display: true,
              type: 'linear',
              id: 'A',
            },
            {
              ticks: { beginAtZero: true },
              gridLines: { display: true },
              position: 'right',
              display: true,
              type: 'linear',
              id: 'B',
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'day',
                unitStepSize: 1,
                displayFormats: { day: 'MMM DD' },
              },
              xAxisID: 'C',
            },
          ],
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datacollection: {
        labels: [],
        datasets: [
          {
            label: 'Carburante Lt',
            yAxisID: 'A',
            fill: false,
            backgroundColor: '#ff0000',
            data: [],
          },
          {
            label: 'Km Percorsi',
            yAxisID: 'B',
            fill: false,
            backgroundColor: '#00ff00',
            data: [],
          },
        ],
      },
      dateX: [],
      fuelY: [],
      kmY: [],
      isHovering: {},
      checkBoxToggle: false,
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    vm.api_serverKft = vm.getKFTServer()
    if (vm.auth === null || vm.auth.tipo == 3) {
      this.$router.push({
        path: 'login',
      })
    }

    ServiceBus.$on('selectedWeek', (obj) => {
      vm.doFindICard(obj)
      vm.startData = obj.start
      vm.endData = obj.end
      vm.reports = []
      vm.totolas = null
      vm.isHovering = null
      vm.selectedDriver = null
    })

    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.theWeek = new Date()
      if (!vm.auth.flag_kft) {
        let lg = vm.nullString(vm.auth.login_kft)
        let pw = vm.nullString(vm.auth.password_kft)
        if (lg.length > 0 && pw.length > 0) {
          vm.$dialog
            .alert('Riprova il collegamento con il server KFT')
            .then(function (dialog) {
              vm.checkKFTServer()
            })
        } else {
          this.$dialog
            .alert('Servizio cronotachigrafo non attivato per ' + vm.auth.nome)
            .then(function (dialog) {
              vm.$router.push({ name: 'Map', params: { pcod: '' } })
            })
        }
      }
      vm.initColumns()
      vm.doLoadDrivers()
      vm.getWindowHeight(null)
    })
  },
  watch: {
    startData(newData, oldData) {
      const vm = this
      if (vm.endData.length > 0 && newData > vm.endData) {
        vm.$dialog
          .alert('Controlllare le date inserite!')
          .then(function () {})
          .catch(function () {})
      }
    },
    endData(newData, oldData) {
      const vm = this
      if (vm.startData.length > 0 && newData < vm.startData) {
        vm.$dialog
          .alert('Controlllare le date inserite!')
          .then(function () {})
          .catch(function () {})
      }
    },
  },
  methods: {
    checkFuture(item) {
      const today = new Date()
      return today.getTime() > item.date.getTime()
    },
    async doFindICard(obj) {
      const vm = this
      const res = await ServiceBus._getTacoCardGroup(
        vm.auth.cod,
        obj.start,
        obj.end
      )
      let icards = []
      if (res.length > 0) {
        res.forEach((item) => {
          if (item.slots[0] !== 'EMPTY') {
            icards.push(item.slots[0])
          }
          if (item.slots[1] !== 'EMPTY') {
            icards.push(item.slots[0])
          }
        })
      }
      let unique = [...new Set(icards)]

      vm.icards_found = []
      let theKey
      let found
      unique.forEach((item) => {
        let element = {}
        element.icard = item

        theKey = item.replace('-', '')

        found = vm.driversRows.find((row) => {
          let card = row.cod_f.replace('-', '')
          return card.indexOf(theKey) >= 0
        })
        if (found) {
          const autista = found.cognome + ' ' + found.nome
          element.autista = autista
        } else {
          element.autista = '-'
        }
        vm.icards_found.push(element)
      })
    },

    async doLoadDrivers() {
      const vm = this
      await vm.doGetDriver()
      await vm.doGetKFTDrivers()
    },
    setStyle(item) {
      const vm = this
      if (item.PerifId === vm.vehicleSel.PerifId) {
        return 'is-item-selected'
      } else {
        return 'is-item-not-selected'
      }
    },
    selectVehicle(item) {
      const vm = this
      vm.vehicleSel = item
    },
    doCarbSearch() {
      const vm = this

      if (vm.endData < vm.startData) {
        vm.$dialog
          .alert('Controlla le date inserite !')
          .then(function (dialog) {})
        return
      }
      if (parseInt(vm.vehicleSel.PerifId) < 0) {
        vm.$dialog
          .alert('Selezionare un mezzo per procedere !')
          .then(function (dialog) {})
        return
      }
      vm.doGetCarburante()
    },
    clickTab(t) {
      let d
      const vm = this
      switch (t) {
        case 2:
          vm.tabNo = t
          break
        case 3:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          vm.doGetListRaw(false)
          break
        case 4:
          vm.tabNo = t
          d = new Date()
          vm.endData = d.toLocaleMysqlString()
          d.setDate(d.getDate() - 1)
          d.setHours(0)
          d.setMinutes(0)
          d.setSeconds(0)
          vm.startData = d.toLocaleMysqlString()
          setTimeout(function () {
            vm.doSearchDDD()
            vm.getWindowHeight(null)
          }, 500)
          vm.recalcFlag = true
          break
        case 5:
          vm.tabNo = t
          setTimeout(function () {
            vm.getWindowHeight(null)
          }, 500)
          vm.doGetKFTDrivers()
          break
      }
    },
    get_image(id, value, row) {
      let img_link
      if (id == 'DDDType') {
        switch (value) {
          case 'C':
            img_link = './images/delivery-man.png'
            break
          case 'M':
            img_link = './images/truck.png'
            break
        }
      }
      if (id == 'DateFromNowDays') {
        let valueDDDtype = row['DDDType']

        switch (valueDDDtype) {
          case 'C':
            img_link = './images/green.png'
            if (value > 20) {
              img_link = './images/yellow.png'
            }
            if (value > 28) {
              img_link = './images/red.png'
            }
            break

          case 'M':
            img_link = './images/green.png'
            if (value > 82) {
              img_link = './images/yellow.png'
            }
            if (value > 90) {
              img_link = './images/red.png'
            }
            break
        }
      }
      return img_link
    },
    isTabActive(t) {
      const vm = this
      if (vm.tabNo == t) {
        return 'is-active'
      } else {
        return ''
      }
    },
    colClick(id, col, row) {
      const vm = this
      if (col.id === 'download') {
        vm.doDownloadDDD(row)
      }
    },
    initColumns() {
      const vm = this

      vm.columnsDDD = [
        {
          id: 'FriendlyName',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Nome',
          width: 300,
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
        {
          id: 'DDDType',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Tipo',
          width: 50,
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          elastic: false,
          filter: '',
          order: 1,
          image: true,
          image_name: '',
        },
        {
          id: 'DDDFileName',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'File',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: true,
          width: 400,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'download',
          visible: true,
          f_type: '*',
          title: 'Download',
          alignment_th: 'center_align',
          mousefeedback: true,
          alignment_td: 'center_align',
          width: 80,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: 'images/download.png',
        },
        {
          id: 'DateFromNowDays',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: '',
          width: 50,
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: '',
        },
        {
          id: 'LastDownloadCompleted',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Data',
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          elastic: false,
          width: 130,
          filter: 'date_reverse_t_filter',
          order: 1,
          image: false,
        },
        {
          id: 'SourceIdentification',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Mezzo',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 150,
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'DriverCard',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'DriverCard',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          width: 150,
          elastic: false,
          filter: 'num.#',
          order: -1,
        },
      ]
      vm.columnsADDD = [
        {
          id: 'FriendlyName',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Nome',
          width: 300,
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
          calcColor: true,
        },
        {
          id: 'DDDType',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Tipo',
          width: 50,
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          elastic: false,
          filter: '',
          order: 1,
          image: true,
          image_name: '',
        },
        {
          id: 'DDDFileName',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'File',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: true,
          width: 400,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'download',
          visible: true,
          f_type: '*',
          title: 'Download',
          alignment_th: 'center_align',
          mousefeedback: true,
          alignment_td: 'center_align',
          width: 80,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: 'images/download.png',
        },
        {
          id: 'LastDownloadCompleted',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Data',
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          elastic: false,
          width: 130,
          filter: 'date_reverse_t_filter',
          order: 1,
          image: false,
        },
        {
          id: 'SourceIdentification',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Mezzo',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 150,
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'DriverCard',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'DriverCard',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          width: 150,
          elastic: false,
          filter: 'num.#',
          order: -1,
        },
      ]
      vm.columnsExpoDrivers = [
        {
          id: 'nomelista',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Nome',
          width: 400,
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
          image_name: '',
        },
        {
          id: 'TacoCardID',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'DriverCard',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          elastic: false,
          width: 200,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'registrato',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'X',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          elastic: true,
          width: 50,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'checked',
          visible: true,
          mousefeedback: true,
          f_type: '*',
          title: '',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: false,
          checkbox: true,
        },
      ]
    },
    async checkKFTServer() {
      const vm = this
      await vm.doLoginKft()
    },
    async doLoginKft() {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'loginkft',
          {
            group: 'SV',
            password: vm.auth.password_kft,
            name: vm.auth.login_kft,
            token: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (response.data.login === 'ok') {
          vm.auth.tkn_kft = response.data.token
          vm.auth.flag_kft = true
          this.$dialog
            .alert('Collegamento con il server KFT riattivato.')
            .then(function (dialog) {})
        } else {
          this.$dialog
            .alert(
              'Errore di connessione con il server KFT. Controllare login o password KFT'
            )
            .then(function (dialog) {})
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    // fillDriverName(a) {
    //   const vm = this
    //   let obj
    //   let name = undefined
    //   for (let i = 0; i < a.length; i++) {
    //     obj = vm.driversRows.find((x) => x.cod_f.indexOf(a[i].DriverCard) >= 0)
    //     if (typeof obj === 'undefined') {
    //       obj = vm.rowsExpoDrivers.find(
    //         (x) => x.TacoCardID.indexOf(a[i].DriverCard) >= 0
    //       )
    //       if (typeof obj !== undefined) {
    //         name = obj.nomelista
    //       }
    //     } else {
    //       name = obj.autista
    //     }
    //     if (typeof name !== 'undefined') {
    //       a[i].Autista = name
    //     } else {
    //       a[i].Autista = ''
    //     }
    //   }
    // },

    doSearchDDD() {
      const vm = this
      vm.rowsADDD = []
      vm.isLoading = true
      vm.doGetArchiveListRaw()
    },

    async doDownloadDDD(obj) {
      const vm = this
      try {
        const response = await axios.get(
          vm.api_server +
            'GetRawFileContent/' +
            obj.UserId +
            '/' +
            obj.DDDFileName +
            '/' +
            vm.auth.tkn_kft,
          {
            responseType: 'arraybuffer',
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]))

          let fileLink = document.createElement('a')

          fileLink.href = fileURL

          fileLink.setAttribute('download', obj.DDDFileName)

          document.body.appendChild(fileLink)

          fileLink.click()
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },

    async doGetListRaw() {
      const vm = this
      vm.isLoading = true
      try {
        const response = await axios.post(
          vm.api_server + 'GetListRaw',
          {
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.isLoading = false
          vm.rowsDDD = response.data.data
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
        vm.rowsDDD = []
      }
    },
    async doGetArchiveListRaw() {
      const vm = this

      let start = vm.newDate(vm.startData).toLocaleMysqlSpecialString(false)
      let end = vm.newDate(vm.endData).toLocaleMysqlSpecialString(true)
      try {
        const response = await axios.post(
          vm.api_server + 'GetArchiveListRaw',
          {
            DateFrom: start,
            DateTo: end,
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.isLoading = false
          vm.rowsADDD = response.data.data
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
        vm.rowsADDD = []
      }
    },
    // async GetListDriverActivityReport(dateFrom, dateTo) {
    //   const vm = this

    //   let start = vm.newDate(dateFrom).toLocaleMysqlString()
    //   let end = vm.newDate(dateTo).toLocaleMysqlString()
    //   vm.isLoading = true
    //   try {
    //     const response = await axios.post(
    //       vm.api_server + 'GetListDriverActivityReport',
    //       {
    //         DateFrom: start,
    //         DateTo: end,
    //         token: vm.auth.tkn_kft,
    //       },
    //       {
    //         headers: {
    //           Authorization: vm.auth.tkn,
    //         },
    //       }
    //     )
    //     if (vm.checkTkn(response.data)) {
    //       console.log(response.data)
    //       vm.rowsReport = response.data.data
    //       vm.createCardIdList()
    //     }
    //   } catch (e) {
    //     console.log('error ' + e)
    //   }
    // },

    extractKFTCognomeNome(full) {
      let obj = {}
      let sep = ''
      let s = full.split(' ')
      s.pop()
      obj.cognome = ''
      obj.nome = ''
      if (s.length === 1) {
        obj.cognome = s[0]
        return obj
      }
      if (s.length === 2) {
        obj.cognome = s[0]
        obj.nome = s[1]
        return obj
      }
      if (s.length > 2) {
        obj.cognome = s[0] + ' ' + s[1]
        obj.nome = ''
        for (let i = 2; i < s.length; i++) {
          obj.nome = obj.nome + sep + s[i]
          sep = ' '
        }
        return obj
      }
      return obj
    },

    async doGetKFTDrivers() {
      const vm = this
      let obj
      vm.isLoading = true
      try {
        const response = await axios.post(
          vm.api_server + 'GetListDriverCard',
          {
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          response.data.data.forEach((element) => {
            obj = vm.extractKFTCognomeNome(element.FirstName.split('-')[0])
            element.nomelista = obj.cognome + ' ' + obj.nome
            element.Nome = obj.nome
            element.Cognome = obj.cognome
            element.registrato = '-'
            element.checked = false
          })
          vm.rowsExpoDrivers = response.data.data
          vm.checkRegistrati()
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },

    async doExport() {
      const vm = this
      let flag = false
      vm.isLoading = true
      for (let i = 0; i < vm.rowsExpoDrivers.length; i++) {
        if (
          vm.rowsExpoDrivers[i].checked &&
          vm.rowsExpoDrivers[i].registrato !== 'X'
        ) {
          flag = true
          await vm.saveDriver(vm.rowsExpoDrivers[i])

          vm.rowsExpoDrivers[i].registrato = 'X'
        }
        vm.rowsExpoDrivers[i].checked = false
      }
      vm.isLoading = false
      if (flag) {
        vm.$dialog
          .alert('Esportazione effettuata')
          .then(function () {})
          .catch(function () {})
      } else {
        vm.$dialog
          .alert('Nessun esportazione effettuata')
          .then(function () {})
          .catch(function () {})
      }
    },
    async saveDriver(driver) {
      const vm = this
      try {
        const response = await axios.post(
          vm.api_server + 'insert_new_driver',
          {
            cod_f: (' ' + driver.TacoCardID).slice(1),
            cod_user: (' ' + vm.auth.cod).slice(1),
            cod_vehicle: '',
            cognome: (' ' + driver.Cognome).slice(1),
            nome: (' ' + driver.Nome).slice(1),
            nick: '',
            email_1: '',
            email_2: '',
            phone_1: '',
            phone_2: '',
            fax_1: '',
            note: '',
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
      } catch (e) {
        console.log('error ' + e)
      }
    },
    doCheckBox() {
      const vm = this
      vm.checkBoxToggle = !vm.checkBoxToggle
      vm.rowsExpoDrivers.forEach((element) => {
        element.checked = vm.checkBoxToggle
      })
    },
    checkRegistrati() {
      const vm = this
      let i, x
      let obj = null
      for (i = 0; i < vm.rowsExpoDrivers.length; i++) {
        obj = vm.driversRows.find(
          (item) => item.cod_f === vm.rowsExpoDrivers[i].TacoCardID
        )
        if (obj === undefined) {
          vm.rowsExpoDrivers[i].registrato = '-'
        } else {
          vm.rowsExpoDrivers[i].registrato = 'X'
        }
      }
    },

    async doGetPlates() {
      const vm = this
      vm.isLoading = true
      try {
        const response = await axios.post(
          vm.api_server + 'GetListPlateFromDDD',
          {
            token: vm.auth.tkn_kft,
          },
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.trucks = response.data.data.filter(function (item) {
            return item.PerifId > 0
          })
          vm.isLoading = false
        }
      } catch (e) {
        console.log('error ' + e)
        vm.isLoading = false
      }
    },
    async doGetDriver() {
      const vm = this
      vm.isLoading = true
      try {
        const response = await axios.get(
          vm.api_server + 'get_drivers/' + vm.auth.cod,
          {
            headers: {
              Authorization: vm.auth.tkn,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.isLoading = false
          vm.driversRows = response.data
        }
      } catch (e) {
        vm.isLoading = false
        console.log('error ' + e)
      }
    },

    // createCardIdList() {
    //   const vm = this
    //   vm.isLoading = false
    //   vm.rowsCardId = []
    //   const map = new Map()
    //   for (const item of vm.rowsReport) {
    //     if (!map.has(item.DriverCard)) {
    //       map.set(item.DriverCard, true) // set any value to Map
    //       vm.rowsCardId.push({ DriverCard: item.DriverCard })
    //     }
    //   }
    //   vm.rowsCardId.sort(function (a, b) {
    //     if (a.DriverCard < b.DriverCard) {
    //       return -1
    //     }
    //     if (a.DriverCard > b.DriverCard) {
    //       return 1
    //     }
    //     return 0
    //   })
    //   vm.fillDriverName(vm.rowsCardId)
    // },
    // clearList() {
    //   const vm = this
    //   vm.rowsCardId = []
    //   vm.chartDataCollection = []
    // },
    // doSearch() {
    //   const vm = this
    //   vm.clearList()
    //   vm.GetListDriverActivityReport(vm.startData, vm.endData)
    // },
    getActivities(n) {
      const activities = ['RIPOSO', 'DISPONIBILE', 'LAVORO', 'GUIDA']
      if (n < activities.length) {
        return activities[n]
      }
      return 'ATT ' + n
    },
    getColors(n) {
      const colors = [
        'color: #008000',
        'color: #00BFFF;',
        'color: #FFD700',
        'color: #FF4500',
      ]
      if (n < colors.length) {
        return colors[n]
      }
      return 'color: #C0C0C0'
    },

    async doGraph(item) {
      const vm = this
      vm.reports = []
      vm.selectedDriver = item
      const icard = item.icard
      let temp = new Date(vm.startData)
      let temp_dates = []
      temp_dates.push(temp)

      for (let i = 0; i < 6; i++) {
        temp = new Date(temp)
        temp.setDate(temp.getDate() + 1)
        temp_dates.push(temp)
      }

      // sorto le date
      // la fn _getReportIcardDay ritorna una promise -> array di promises
      const weeklyReportPromises = temp_dates
        .sort((a, b) => a.getTime() - b.getTime())
        .map((it) => ServiceBus._getReportIcardDay(icard, it))

      // dates.forEach(async (theDate) => {
      //   console.log('theDate', theDate)
      //   rep = await ServiceBus._getReportIcardDay(icard, theDate)
      //   if (rep) {
      //     rep.key = 'reports' + i
      //     rep.date = theDate
      //     temp_reports.push(rep)
      //     i++
      //   }
      // })
      try {
        vm.reports = await Promise.all(weeklyReportPromises)
        vm.calcTotal()
      } catch (e) {
        console.log('error', e)
      }
    },

    calcTotal() {
      const vm = this
      vm.total = {}
      vm.total.guida_tot = 0
      vm.total.riposo_tot = 0
      vm.total.lavoro_tot = 0
      vm.total.err_tot = 0
      vm.total.disp_tot = 0

      vm.reports.forEach((element) => {
        if (element.report) {
          if (element.report.guida_tot) {
            vm.total.guida_tot += element.report.guida_tot
          }
          if (element.report.riposo_tot) {
            vm.total.riposo_tot += element.report.riposo_tot
          }
          if (element.report.lavoro_tot) {
            vm.total.lavoro_tot += element.report.lavoro_tot
          }
          if (element.report.err_tot) {
            vm.total.err_tot += element.report.err_tot
          }
          if (element.report.disp_tot) {
            vm.total.disp_tot += element.report.disp_tot
          }
        }
      })
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight

      let ele1 = vm.$refs['icardList']
      if (ele1) {
        ele1.setAttribute('style', 'height:' + (vm.windowHeight - 300) + 'px')
      }
      // let ele2 = document.getElementById('graphBox')
      // if (ele2) {
      //   ele2.setAttribute('style', 'height:' + (vm.windowHeight - 125) + 'px')
      //   vm.grapBoxWidth = ele2.offsetWidth
      // }
      let ele4 = document.getElementById('KFT004bw')
      if (ele4) {
        ele4.setAttribute('style', 'height:' + (vm.windowHeight - 300) + 'px')
      }
      // let ele5 = document.getElementById(vm.optionsDaily.id)
      // if (ele5) {
      //   ele5.setAttribute('style', 'height:' + (vm.windowHeight - 150) + 'px')
      // }
      // let ele6 = document.getElementById(vm.optionsWeekly.id)
      // if (ele6) {
      //   ele6.setAttribute('style', 'height:' + (vm.windowHeight - 150) + 'px')
      // }
      // let ele7 = document.getElementById('grafico')
      // if (ele7) {
      //   ele7.setAttribute('style', 'height:' + (vm.windowHeight - 250) + 'px')
      // }
      //exportdrivers
      let ele8 = document.getElementById('KFT005bw')
      if (ele8) {
        ele8.setAttribute('style', 'height:' + (this.windowHeight - 195) + 'px')
      }
      // let ele10 = document.getElementById('KFT001bw')
      // if (ele10) {
      //   ele10.setAttribute(
      //     'style',
      //     'height:' + (this.windowHeight - 180) + 'px'
      //   )
      // }
      // let ele11 = document.getElementById('KFT002bw')
      // if (ele11) {
      //   ele11.setAttribute(
      //     'style',
      //     'height:' + (this.windowHeight - 180) + 'px'
      //   )
      // }
      let ele3 = document.getElementById('KFT003bw')
      if (ele3) {
        ele3.setAttribute('style', 'height:' + (vm.windowHeight - 180) + 'px')
      }
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
<style scoped>
.border {
  border-style: solid;
  border-width: 1px;
}
.parent {
  font-size: 12px;
  height: auto;
  overflow-x: hidden;
  overflow-y: scroll;
}
.title_drivername {
  padding: 5px;
}

.graphRow {
  padding: 5px;
}

.rowDate {
  padding: 5px;
}
</style>
